import { EmployerAdvisorsShell } from '@/modules/employerAdvisors/pages/components/EmployerAdvisorsShell/EmployerAdvisorsShell'

export function Component() {
  return <EmployerAdvisorsShell />
}

Component.displayName = 'EmployerAdvisors'
